import '../../FairnessModal.scss'
import { DEFAULT_GAME_ID } from 'constants/index'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import GenericResultModal from '../GenericResultModal'
import { MAX_MINE_COUNT } from 'games/Mines/GameTheme/GongaMineGame/mineGame.constants'
import { roundVerifyHash } from 'redux-store/thunk/gameSettings.thunk'
import KenoFairnessModalResult from 'games/Keno/GameTheme/KenoGame/components/FairnessModal/KenoFairnessModalResult'
import DiceFairnessModalResult from 'games/Dice/GameTheme/DiceGame/components/FairnessModal/DiceFairnessModalResult'
import HiloFairnessModalResult from 'games/HiLo/GameTheme/HiLoGame/components/FairnessModal/HiloFairnessModalResult'
import MineFairnessModalResult from 'games/Mines/GameTheme/GongaMineGame/components/FairnessMineTable/index'
import { blockSpaceChar } from 'helpers/common.helpers'
import FlipCoinFairnessModalResult from 'games/FlipCoin/GameTheme/FlipCoinGame/components/FairnessModal/FlipCoinFairnessModalResult'
import TowerFairnessModalResult from 'games/TowerGame/components/Modals/FairnessModal/TowerFairnessModalResult'
import BbCrossFairnessModalResult from 'games/BbCrossGame/GameTheme/BbCross/components/FairnessModal/index'
import { isEmpty } from 'lodash'
import { DEFAULT_MIN_PYRAMID_PLINKO_ROWS, PYRAMID_PLINKO_GAME_RISK_LEVEL } from 'games/Plinko/GameTheme/PyramidPlinkoGame/pyramidPlinkogame.constants'
import { TOWER_DIFFICULTY_LEVELS, TOWER_GAME_MODES } from 'games/TowerGame/tower.constants'
import { useTranslation } from 'react-i18next'

const VerifyTab = ({ gameId, handleCopyCode, clientSeed, setClientSeed, serverSeed, setServerSeed, resultData, roundBetHistory, hashCode, setHashCode }) => {

  const dispatch = useDispatch()
  const [numberOfMines, setNumberOfMines] = useState(3)
  const [numberOfGongaMines, setNumberOfGongaMines] = useState(5)
  const [numberOfRows, setNumberOfRows] = useState(roundBetHistory ? roundBetHistory?.numberOfRows : 8)
  const [riskLevel, setRiskLevel] = useState(roundBetHistory ? roundBetHistory?.riskLevel : 1)
  const [verify, setVerify] = useState(false)
  const [verifiedDice, setVerifiedDice] = useState(null)
  const { roundHashDetails } = useSelector((state) => state.gameSetting)

  const [towerGameConfig, setTowerGameConfig] = useState({
    difficultyType: resultData?.difficultyType || TOWER_DIFFICULTY_LEVELS?.[0].difficulty,
    gameModeType: resultData?.gameModeType || TOWER_GAME_MODES?.[0]
  })
const { t } = useTranslation()
  const resultModal = [
    {
      gameId: DEFAULT_GAME_ID.KENO,
      component: KenoFairnessModalResult
    },
    {
      gameId: DEFAULT_GAME_ID.DICE,
      component: DiceFairnessModalResult
    },
    {
      gameId: DEFAULT_GAME_ID.HILO,
      component: HiloFairnessModalResult
    },
    {
      gameId: DEFAULT_GAME_ID.GONGA_MINE,
      component: MineFairnessModalResult
    },
    {
      gameId: DEFAULT_GAME_ID.COIN_FLIP,
      component: FlipCoinFairnessModalResult
    },
    {
      gameId: DEFAULT_GAME_ID.CROSS,
      component: BbCrossFairnessModalResult
    },
    {
      gameId: DEFAULT_GAME_ID.TOWER,
      component: TowerFairnessModalResult
    }
  ]

  const ResultModalRenderingFunction = ({ gameId, roundHashDetails }) => {
    const fairnessResultSection = resultModal.find(modal => +modal.gameId === gameId)

    if (fairnessResultSection && fairnessResultSection.component) {
      const ResultModal = fairnessResultSection.component
      if (+gameId === +DEFAULT_GAME_ID.DICE) {
        return (
          <ResultModal
            {...roundHashDetails}
            number={verifiedDice?.number}
            rollOver={verifiedDice?.rollOver}
          />
        )
      }
      return gameId === DEFAULT_GAME_ID.TOWER
        ? <ResultModal
          provableFairResult={roundHashDetails}
          towerGameConfig={towerGameConfig}
        />
        : <ResultModal {...roundHashDetails} />
    } else if (+gameId === +DEFAULT_GAME_ID.SPACE_DICE) {
      return <GenericResultModal gameResult={roundHashDetails?.result || 50} />
    } else {
      return <GenericResultModal gameResult={roundHashDetails?.multiplier} />
    }
  }

  const handleHashChange = (value) => {
    setHashCode(value)
  }

  useEffect(() => {
    setVerifiedDice(null) // seeds changed → back to default until verified again
    if (clientSeed && serverSeed && clientSeed.trim().length > 1 && serverSeed.trim().length > 1) {
      setVerify(true)
    } else {
      setVerify(false)
    }
  }, [clientSeed, serverSeed])

  const handleVerifySeeds = () => {
    if (verify) {
      const gameModeType = towerGameConfig.gameModeType
      const difficultyType = towerGameConfig.difficultyType
      dispatch(roundVerifyHash({ gameId, clientSeed, serverSeed, numberOfRows, numberOfMines, riskLevel, numberOfGongaMines, gameModeType, difficultyType }))
      if (+gameId === +DEFAULT_GAME_ID.DICE) {
        setVerifiedDice({
          number: roundBetHistory?.number ?? resultData?.number,
          rollOver: roundBetHistory?.rollOver ?? resultData?.rollOver
        })
      }
    }
  }

  if (+gameId === +DEFAULT_GAME_ID.CRASH || +gameId === +DEFAULT_GAME_ID.CHOPPER_CRASH || +gameId === +DEFAULT_GAME_ID.MULTI_CRASH || +gameId === +DEFAULT_GAME_ID.SOCCER_CRASH) {
    return (
      <>
        <div className='mb-3'>
          <GenericResultModal gameResult={roundHashDetails?.crashRate} />
        </div>
        <div className='form-group'>
          <label className='form-label'>{t('HASH')}</label>
          <div className='input-group'>
            <input
              type='text'
              className='form-control shadow-none'
              style={{ paddingLeft: '1rem', paddingRight: '3.5rem' }}
              value={hashCode}
              onKeyDown={blockSpaceChar}
              onChange={(e) => handleHashChange(e.target.value)}
              placeholder={t('ENTER_ROUND_HASH')}
            />
          </div>
        </div>
        <button
          className='btn text-capitalize gradient-btn w-100 my-3'
          onClick={(e) => {
            e.preventDefault()
            dispatch(roundVerifyHash({ hashCode, gameId }))
          }}
          disabled={isEmpty(hashCode)}
        >
          {t('VERIFY')}
        </button>
      </>
    )
  }

  let otherFieldsJSX = (<></>)

  switch (gameId) {
    case DEFAULT_GAME_ID.MINE:
      otherFieldsJSX = (
        <div className='form-group order-1 order-lg-0'>
          <label className='form-label'>
            {t('MINES')}
          </label>
          <div className='input-group'>
            <select
              className='form-control'
              value={numberOfMines}
              onChange={(e) => setNumberOfMines(+e.target.value)}
              name='mines'
              size={1}
              id='mines'
            >
              {Array.from({ length: MAX_MINE_COUNT }, (_, i) => i + 1).map((mine) => {
                return (
                  <option key={mine} value={mine}>
                    {mine}
                  </option>
                )
              })}
            </select>
          </div>
        </div>
      )
      break
    case DEFAULT_GAME_ID.GONGA_MINE:
      otherFieldsJSX = (
        <div className='form-group order-1 order-lg-0'>
          <label className='form-label'>
            {t('MINES')}
          </label>
          <div className='input-group'>
            <select
              className='form-control'
              value={numberOfGongaMines}
              onChange={(e) => setNumberOfGongaMines(+e.target.value)}
              name='mines'
              size={1}
              id='mines'
            >
              {Array.from({ length: MAX_MINE_COUNT }, (_, i) => i + 1).map((mine) => {
                return (
                  <option key={mine} value={mine}>
                    {mine}
                  </option>
                )
              })}
            </select>
          </div>
        </div>
      )
      break

    case DEFAULT_GAME_ID.PLINKO:
    case DEFAULT_GAME_ID.PYRAMID_PLINKO:
      otherFieldsJSX = (
        <>
          <div className='form-group order-1 order-lg-0 mb-3'>
            <label className='form-label'>
              {t('RISK_LEVEL')}
            </label>
            <div className='input-group'>
              <select
                className='form-control'
                value={riskLevel}
                onChange={(e) => setRiskLevel(+e.target.value)}
                name='plinkoRiskLevel'
                size={1}
                id='plinkoRiskLevel'
              >
                {PYRAMID_PLINKO_GAME_RISK_LEVEL
                  .map((row) => {
                    return (
                      <option key={row.value} value={row.value}>
                        {t(row.label.toUpperCase())}
                      </option>
                    )
                  })}
              </select>
            </div>
          </div>
          <div className='form-group order-1 order-lg-0'>
            <label className='form-label'>
              {t('ROWS')}
            </label>
            <div className='input-group'>
              <select
                className='form-control'
                value={numberOfRows}
                onChange={(e) => setNumberOfRows(+e.target.value)}
                name='plinkoRow'
                size={1}
                id='plinkoRow'
              >
                {Array.from({ length: DEFAULT_MIN_PYRAMID_PLINKO_ROWS + 1 }, (_, i) => DEFAULT_MIN_PYRAMID_PLINKO_ROWS + i).map((rowValue) => {
                  return (
                    <option key={rowValue} value={rowValue}>
                      {rowValue}
                    </option>
                  )
                })}
              </select>
            </div>
          </div>
        </>
      )
      break
    case DEFAULT_GAME_ID.TOWER:
      otherFieldsJSX = (
        <>
          <div className='form-group order-1 order-lg-0 mb-3'>
            <label className='form-label'>{t('GAME_MODE')}</label>
            <div className='input-group'>
              <select
                className='form-control text-capitalize'
                value={towerGameConfig.gameModeType}
                onChange={(e) =>
                  setTowerGameConfig((prev) => ({ ...prev, gameModeType: e.target.value }))}
                name='game-mode-type'
                size={1}
                id='tower-game-mode'
              >
                {TOWER_GAME_MODES.map((type, idx) => {
                  return (
                    <option key={idx} value={type}>
                      {t(type.toUpperCase())}
                    </option>
                  )
                })}
              </select>
            </div>
          </div>

          <div className='form-group order-1 order-lg-0 mb-3'>
            <label className='form-label'>{t('DIFFICULTY_TYPE')}</label>
            <div className='input-group'>
              <select
                className='form-control text-capitalize'
                value={towerGameConfig.difficultyType}
                onChange={(e) =>
                  setTowerGameConfig((prev) => ({ ...prev, difficultyType: e.target.value }))}
                name='tower-difficulty-type'
                size={1}
                id='tower-tower-difficulty'
              >
                {TOWER_DIFFICULTY_LEVELS.map(({ difficulty }, idx) => {
                  return (
                    <option key={idx} value={difficulty}>
                      {t(difficulty.toUpperCase())}
                    </option>
                  )
                })}
              </select>
            </div>
          </div>
        </>
      )
      break

    // case DEFAULT_GAME_ID.KENO:
    //   otherFieldsJSX = (
    //     <>
    //       <div className='form-group order-1 order-lg-0'>
    //         <label className='form-label'>
    //           Risk Level
    //         </label>
    //         <div className='input-group'>
    //           <select
    //             className='form-control'
    //             value={riskLevel}
    //             onChange={(e) => setRiskLevel(+e.target.value)}
    //             name='kenoRiskLevel'
    //             size={1}
    //             id='kenoRiskLevel'
    //           >
    //             {KENO_GAME_RISK_LEVEL.map((row) => {
    //               return (
    //                 <option key={row.value} value={row.value}>
    //                   {t(row.label.toUpperCase())}
    //                 </option>
    //               )
    //             })}
    //           </select>
    //         </div>
    //       </div>
    //     </>
    //   )
    //   break

    default:
      otherFieldsJSX = <></>
      break
  }

  return (
    <>
      <div className='mb-3'>
        <>
          <ResultModalRenderingFunction gameId={gameId} roundHashDetails={roundHashDetails} />
        </>
      </div>
      <div className='form-group mb-3'>
        <label className='form-label'>{t('CLIENT_SEED')}</label>
        <div className='input-group'>
          <input
            type='text'
            value={clientSeed}
            className='form-control shadow-none'
            style={{ paddingLeft: '1rem', paddingRight: '3.5rem' }}
            onKeyDown={blockSpaceChar}
            onChange={(e) => {
              setClientSeed(e?.target?.value)
            }}
            placeholder={t('ENTER_CLIENT_SEED')}
            required
          />
        </div>
      </div>
      <div className='form-group mb-3'>
        <label className='form-label'>{t('SERVER_SEED')}</label>
        <div className='input-group'>
          <input
            type='text'
            value={serverSeed}
            className='form-control shadow-none'
            placeholder={t('ENTER_SERVER_SEED')}
            style={{ paddingLeft: '1rem', paddingRight: '3.5rem' }}
            onChange={(e) => {
              setServerSeed(e?.target?.value)
            }}
            onKeyDown={blockSpaceChar}
            required
          />
        </div>
      </div>
      {otherFieldsJSX}
      <button
        className='verify-btn gradient-btn btn-secondary text-capitalize w-100 my-3'
        disabled={!verify}
        onClick={(e) => {
          e.preventDefault()
          handleVerifySeeds()
        }}
      >
        {t('VERIFY')}
      </button>
    </>
  )
}

export default VerifyTab
